export default "__VITE_ASSET__DUdvj$EX__"